<template>
    <common readOnly></common>
</template>
<script>
import common from './common.vue';

export default {
    name: 'commercialInvoiceDetail',
    components: {
        common,
    },
};
</script>
